export default __webpack_public_path__ + "static/media/chevron.9d4f3651.svg";